import { FeedProductListPreviewView } from '../../../../../modules/Plus/Event/S/Tmpl/form';
import { each, pipe } from '@fxts/core';

export const hydrateFeed = (page_element: HTMLElement) => {
  const product_embed_preview_els = page_element.querySelectorAll('.FeedProductListPreviewView:not(script)');
  pipe(
    product_embed_preview_els,
    each((element) => {
      FeedProductListPreviewView.createAndHydrate(element as HTMLElement);
    }),
  );
};
